var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaystackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1368 0.520691H0.930193C0.444875 0.520691 0 0.965612 0 1.49143V3.19022C0 3.71604 0.444875 4.16096 0.930193 4.16096H16.1368C16.6626 4.16096 17.067 3.71604 17.1075 3.19022V1.49143C17.1075 0.965612 16.6626 0.520691 16.1368 0.520691ZM16.1368 10.0663H0.930193C0.687534 10.0663 0.444875 10.1876 0.242659 10.3494C0.0808863 10.5112 0 10.7539 0 11.037V12.7358C0 13.2616 0.444875 13.7065 0.930193 13.7065H16.1368C16.6626 13.7065 17.067 13.3021 17.1075 12.7358V11.037C17.1075 10.4708 16.6626 10.0663 16.1368 10.0663ZM9.50414 14.8391H0.930193C0.687534 14.8391 0.444875 14.92 0.283102 15.1222C0.12133 15.284 0 15.5267 0 15.8098V17.5086C0 18.0344 0.444875 18.4793 0.930193 18.4793H9.4637C9.98946 18.4793 10.3939 18.0344 10.3939 17.5086V15.7694C10.4343 15.2435 10.0299 14.8391 9.50414 14.8391ZM17.1075 5.29348H0.930193C0.687534 5.29348 0.444875 5.37438 0.283102 5.57662C0.12133 5.73841 0 5.98109 0 6.26422V7.96301C0 8.48883 0.444875 8.93375 0.930193 8.93375H17.067C17.5928 8.93375 17.9972 8.48883 17.9972 7.96301V6.26422C18.0377 5.73841 17.6332 5.29348 17.1075 5.29348Z",
    fill: "#00C3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystackIcon);
export default __webpack_public_path__ + "static/media/paystack-icon.fe68b082a3590e590aaf67bc042a7f66.svg";
export { ForwardRef as ReactComponent };